import React, { useEffect, useRef } from "react";
import { Center } from "@mantine/core";
import { sizes } from "../../constants/sizes";
import { useTheme } from "../../common/hooks";
import { useProgress } from "@react-three/drei";
import gsap from "gsap";
import { themeKeys } from "../../constants/themes";

export default function Loading() {
  const { theme, themeKey } = useTheme();
  const { progress } = useProgress();

  const logo = useRef();
  const window = useRef();
  const wall = useRef();
  const floor = useRef();

  const logoStyle = {
    position: "relative",
    textAlign: "center",
    width: "200px",
    height: "200px",
    scale: 0.3,
  };

  useEffect(() => {
    const tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });
    tl.fromTo(
      logo.current,
      { scale: 0.3 },
      { scale: 0.5, duration: 0.5, ease: "power2.easeInOut" }
    );
    tl.to(
      window.current,
      { x: 200, duration: 0.5, ease: "power2.easeIn" },
      "<"
    );
    tl.to(wall.current, { x: -200, duration: 0.5, ease: "power2.easeIn" }, "<");
    tl.to(floor.current, { y: 200, duration: 0.5, ease: "power2.easeIn" }, "<");
    tl.to(
      logo.current,
      {
        rotate: 360,
        duration: 1,
        ease: "power2.inOut",
      },
      "<"
    );
    tl.to(
      window.current,
      { x: 0, duration: 0.4, ease: "power2.Out", delay: 0.5 },
      "<"
    );
    tl.to(wall.current, { x: 0, duration: 0.4, ease: "power2.Out" }, "<");
    tl.to(floor.current, { y: 0, duration: 0.4, ease: "power2.Out" }, "<");
    tl.to(logo.current, { scale: 0.3, duration: 0.3 }, "<");
  }, []);

  return (
    <Center
      style={{
        width: sizes.width,
        height: sizes.height,
        background: theme.bg,
        color: theme.primaryText,
        background:
          "linear-gradient(180deg, #00000A 0%, #082B4A 30%, #0062FA 70%, #9AEEFF 100%)",
        backgroundSize: "400% 400%",
        backgroundPosition: themeKey === themeKeys.DARK ? "90% 0%" : "0% 90%",
        transition: "all 3s ease-out",
      }}
    >
      <div style={logoStyle} ref={logo}>
        <img
          style={{
            position: "absolute",
            right: 25,
            bottom: -20,
            scale: 0.5,
          }}
          src={process.env.PUBLIC_URL + "images/logo/wall-logo.png"}
          alt="wall-logo"
          ref={wall}
        />
        <img
          style={{
            position: "absolute",
            left: 25,
            bottom: -20,
            scale: 0.5,
          }}
          src={process.env.PUBLIC_URL + "images/logo/window-logo.png"}
          alt="window-logo"
          ref={window}
        />

        <img
          style={{
            position: "absolute",
            left: -28,
            bottom: -110,
            scale: 0.5,
          }}
          src={process.env.PUBLIC_URL + "images/logo/floor-logo.png"}
          alt="floor-logo"
          ref={floor}
        />
      </div>
    </Center>
  );
}
